import type { FC } from "react";

import { Typography } from "@aviary";

import * as styles from "./BrandName.styles";

interface Props {
  name: string;
  isNoClip?: boolean;
}

const BrandName: FC<Props> = ({ name, isNoClip, ...rest }) => {
  const brandStyles = [styles.brandName, isNoClip && styles.noClip];
  return (
    <Typography isMarginless css={brandStyles} title={name} {...rest}>
      {name}
    </Typography>
  );
};

export { BrandName };
